import React, { useEffect, useState, Fragment } from 'react';
import { Modal, Table, Spin, Icon } from 'antd';

const scheduleStyles = `
@keyframes schedule-fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes schedule-slideUp {
  from { opacity: 0; transform: scale(0.98) translateY(15px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes schedule-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
@keyframes schedule-shimmer {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}
@keyframes schedule-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

/* Modal Overrides */
.schedule-modal .ant-modal-content {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 24px 48px rgba(0,0,0,0.12), 0 0 0 1px rgba(24,144,255,0.1) !important;
  animation: schedule-slideUp 0.3s cubic-bezier(0.22, 1, 0.36, 1) both !important;
}
.schedule-modal .ant-modal-header {
  background: linear-gradient(135deg, #0c4e6e 0%, #0891b2 40%, #06b6d4 75%, #22d3ee 100%);
  padding: 18px 24px !important;
  border-bottom: none !important;
  position: relative;
  overflow: hidden;
}
.schedule-modal .ant-modal-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  pointer-events: none;
}
.schedule-modal .ant-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #22d3ee, #06b6d4, #0891b2, #0c4e6e, #22d3ee);
  background-size: 300% auto;
  animation: schedule-shimmer 3s linear infinite;
}
.schedule-modal .ant-modal-title {
  color: #fff !important;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
}
.schedule-modal .ant-modal-close {
  top: 16px !important;
  right: 20px !important;
  color: rgba(255,255,255,0.8) !important;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1) !important;
}
.schedule-modal .ant-modal-close:hover {
  color: #fff !important;
  transform: rotate(90deg) scale(1.1) !important;
}
.schedule-modal .ant-modal-close .ant-modal-close-x {
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
}
.schedule-modal .ant-modal-body {
  padding: 0 !important;
  background: #f8fafc;
}
.schedule-modal .ant-modal-footer {
  display: none !important;
}

/* Header Icon & Title */
.schedule-header-icon {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-right: 8px;
}
.schedule-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1.5px solid rgba(255,255,255,0.3);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  animation: schedule-float 3s ease-in-out infinite;
}
.schedule-title-main {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.8px;
}
.schedule-title-sub {
  font-size: 11px;
  color: rgba(255,255,255,0.75);
  letter-spacing: 0.5px;
  margin-top: 2px;
  font-weight: 400;
}

/* Content Area */
.schedule-content {
  padding: 20px 24px 24px;
  background: #f8fafc;
}

/* Info Cards */
.schedule-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}
.schedule-info-card {
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  border-radius: 12px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
}
.schedule-info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.08);
  border-color: #cbd5e1;
}
.schedule-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #64748b;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.schedule-info-value {
  font-size: 20px;
  font-weight: 800;
  color: #0891b2;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.schedule-info-unit {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

/* Table Customization */
.schedule-table-wrapper {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.2s ease;
}
.schedule-table-wrapper:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}
.schedule-modal .ant-table {
  background: transparent !important;
  font-size: 13px !important;
}
.schedule-modal .ant-table-thead > tr > th {
  background: linear-gradient(180deg, #f1f5f9 0%, #e9eef3 100%) !important;
  color: #0f172a !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #cbd5e1 !important;
  padding: 12px 16px !important;
}
.schedule-modal .ant-table-tbody > tr > td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155 !important;
}
.schedule-modal .ant-table-tbody > tr:hover > td {
  background: #fefce8 !important;
  transition: background 0.2s ease;
}
.schedule-modal .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

/* Status Badge Styling for remaining quantities */
.schedule-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}
.schedule-status-completed {
  background: #dcfce7;
  color: #15803d;
}
.schedule-status-pending {
  background: #fef3c7;
  color: #b45309;
}
.schedule-status-progress {
  background: #dbeafe;
  color: #1e40af;
}

/* Empty State */
.schedule-empty {
  text-align: center;
  padding: 48px 24px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}
.schedule-empty-icon {
  font-size: 48px;
  color: #cbd5e1;
  margin-bottom: 16px;
}
.schedule-empty-text {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}

/* Loading Overlay */
.schedule-modal .ant-spin-nested-loading {
  min-height: 200px;
}
.schedule-modal .ant-spin-blur {
  opacity: 0.5;
}
.schedule-modal .ant-spin-dot {
  color: #0891b2 !important;
}
`;

const PoDeliverySchedule = props => {
  const {
    itemDeliverySchedule: { id, po_number, supplier, total_qty },
    closeModal,
    getPoDeliverySchedule,
  } = props;
  const [itemSchedule, setItems] = useState([]);
  const [isLoading, setLoading] = useState(false);
  
  useEffect(() => {
    setLoading(true);
    getPoDeliverySchedule(id)
      .then(res => {
        setItems(res || []);
      })
      .catch(err => {
        console.error('Error fetching schedule:', err);
        setItems([]);
      })
      .finally(() => setLoading(false));
  }, [id, getPoDeliverySchedule]);

  // Calculate summary statistics
  const calculateSummary = () => {
    if (!itemSchedule || itemSchedule.length === 0) return null;
    
    const totalQuantity = itemSchedule.reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);
    const totalRemaining = itemSchedule.reduce((sum, item) => sum + (parseFloat(item.remaining) || 0), 0);
    const completedDeliveries = itemSchedule.filter(item => parseFloat(item.remaining) === 0).length;
    
    return {
      totalQuantity,
      totalRemaining,
      completedDeliveries,
      totalDeliveries: itemSchedule.length,
      completionRate: (completedDeliveries / itemSchedule.length) * 100
    };
  };

  const summary = calculateSummary();

  const columns = [
    {
      key: 'date',
      dataIndex: 'date',
      title: 'Date',
      align: 'center',
      render: (text) => text || '—',
      onCell: () => ({ style: { fontWeight: '500' } })
    },
    {
      key: 'quantity',
      dataIndex: 'quantity',
      title: 'Quantity',
      align: 'center',
      render: (text) => text ? text.toLocaleString() : '—',
    },
    {
      key: 'remaining',
      dataIndex: 'remaining',
      title: 'Remaining',
      align: 'center',
      render: (text) => {
        const remaining = parseFloat(text);
        if (isNaN(remaining)) return '—';
        
        let statusClass = 'schedule-status-pending';
        let statusText = 'Pending';
        
        if (remaining === 0) {
          statusClass = 'schedule-status-completed';
          statusText = 'Completed';
        } else if (remaining > 0) {
          statusClass = 'schedule-status-progress';
          statusText = 'In Progress';
        }
        
        return (
          <span className={`schedule-status-badge ${statusClass}`}>
            {text.toLocaleString()}
          </span>
        );
      },
    },
    {
      key: 'remarks',
      dataIndex: 'remarks',
      title: 'Remarks',
      align: 'center',
      render: (text) => text || '—',
    },
    {
      key: 'commited_qty',
      dataIndex: 'commited_qty',
      title: 'Production Qty',
      align: 'center',
      render: (text) => text ? text.toLocaleString() : '—',
    },
    {
      key: 'prod_remarks',
      dataIndex: 'prod_remarks',
      title: 'Production Remarks',
      align: 'center',
      render: (text) => text || '—',
    },
    {
      key: 'others',
      dataIndex: 'others',
      title: 'Others',
      align: 'center',
      render: (text) => text || '—',
    }
  ];

  return (
    <>
      <style>{scheduleStyles}</style>
      <Modal
        className="schedule-modal"
        visible={true}
        title={
          <div className="schedule-header-icon">
            <div className="schedule-icon-wrap">
              <Icon type="schedule" style={{ fontSize: 18, color: '#fff' }} />
            </div>
            <div>
              <div className="schedule-title-main">ITEM DELIVERY SCHEDULE</div>
              {po_number && (
                <div className="schedule-title-sub">
                  PO #{po_number} • {supplier || 'View delivery details'}
                </div>
              )}
            </div>
          </div>
        }
        width="85%"
        style={{ top: 20 }}
        onCancel={() => isLoading ? null : closeModal({ visible: false })}
        footer={null}
      >
        <div className="schedule-content">
          {/* Statistics Cards */}
          {summary && itemSchedule.length > 0 && (
            <div className="schedule-info-grid">
              <div className="schedule-info-card">
                <div className="schedule-info-label">
                  <Icon type="profile" style={{ fontSize: 12 }} />
                  Total Deliveries
                </div>
                <div className="schedule-info-value">
                  {summary.totalDeliveries}
                  <span className="schedule-info-unit">schedules</span>
                </div>
              </div>
              <div className="schedule-info-card">
                <div className="schedule-info-label">
                  <Icon type="shopping-cart" style={{ fontSize: 12 }} />
                  Total Quantity
                </div>
                <div className="schedule-info-value">
                  {summary.totalQuantity.toLocaleString()}
                  <span className="schedule-info-unit">units</span>
                </div>
              </div>
              <div className="schedule-info-card">
                <div className="schedule-info-label">
                  <Icon type="check-circle" style={{ fontSize: 12 }} />
                  Completed Deliveries
                </div>
                <div className="schedule-info-value">
                  {summary.completedDeliveries}
                  <span className="schedule-info-unit">
                    / {summary.totalDeliveries}
                  </span>
                </div>
              </div>
              <div className="schedule-info-card">
                <div className="schedule-info-label">
                  <Icon type="line-chart" style={{ fontSize: 12 }} />
                  Completion Rate
                </div>
                <div className="schedule-info-value">
                  {Math.round(summary.completionRate)}%
                  <span className="schedule-info-unit">complete</span>
                </div>
              </div>
            </div>
          )}

          {/* Table Section */}
          <div className="schedule-table-wrapper">
            <Spin spinning={isLoading}>
              {itemSchedule && itemSchedule.length > 0 ? (
                <Table
                  bordered={true}
                  size="middle"
                  columns={columns}
                  dataSource={itemSchedule}
                  pagination={false}
                  rowKey="id"
                  scroll={{ x: 'max-content' }}
                />
              ) : (
                !isLoading && (
                  <div className="schedule-empty">
                    <div className="schedule-empty-icon">
                      <Icon type="inbox" />
                    </div>
                    <div className="schedule-empty-text">
                      No delivery schedule found
                    </div>
                    <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 8 }}>
                      No schedules available for this purchase order
                    </div>
                  </div>
                )
              )}
            </Spin>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PoDeliverySchedule;